import dayjs from 'dayjs';
import { ProductWarehouseStatus } from 'features/inventory/products/constants';

export const toDateValue = (value: unknown): Date | null => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string') {
    // Backend can return date strings in DD/MM/YYYY for some endpoints.
    const ddMmYyyyMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (ddMmYyyyMatch) {
      const [, dd, mm, yyyy] = ddMmYyyyMatch;
      const parsed = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
  }

  const parsed = dayjs(value as any);
  return parsed.isValid() ? parsed.toDate() : null;
};

export const getStatusKey = (value: unknown): string | null => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    if (trimmed in ProductWarehouseStatus) {
      return trimmed;
    }

    const statusByNumericValue = Object.entries(ProductWarehouseStatus).find(
      ([, numericValue]) => String(numericValue) === trimmed
    );
    return statusByNumericValue ? statusByNumericValue[0] : null;
  }

  if (typeof value === 'number') {
    const statusByNumericValue = Object.entries(ProductWarehouseStatus).find(
      ([, numericValue]) => numericValue === value
    );
    return statusByNumericValue ? statusByNumericValue[0] : null;
  }

  return null;
};
